module.exports = __webpack_public_path__ + "static/img/6.d2187c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/sp/6.png
// module id = b2J7
// module chunks = 0